export default __webpack_public_path__ + "static/media/PhoneLogin.0943c2d8.png";